import apiClient from './apiClient';
import { LoginRequest, LoginResponse, ForgotPasswordRequest, ResetPasswordRequest, AdminUser, CreateUserRequest, UpdateUserRequest, UpdatePasswordRequest } from '../types/Auth';

const authApiClient = apiClient;

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await authApiClient.post<LoginResponse>('/api/auth/login', credentials);
    return response.data;
  },

  forgotPassword: async (request: ForgotPasswordRequest): Promise<void> => {
    await authApiClient.post('/api/auth/forgot-password', request);
  },

  resetPassword: async (request: ResetPasswordRequest): Promise<void> => {
    await authApiClient.post('/api/auth/reset-password', request);
  },

  // Admin Users management
  getAllUsers: async (): Promise<AdminUser[]> => {
    const response = await authApiClient.get<AdminUser[]>('/api/adminusers');
    return response.data;
  },

  getUserById: async (id: number): Promise<AdminUser> => {
    const response = await authApiClient.get<AdminUser>(`/api/adminusers/${id}`);
    return response.data;
  },

  createUser: async (user: CreateUserRequest): Promise<AdminUser> => {
    const response = await authApiClient.post<AdminUser>('/api/adminusers', user);
    return response.data;
  },

  updateUser: async (id: number, user: UpdateUserRequest): Promise<AdminUser> => {
    const response = await authApiClient.put<AdminUser>(`/api/adminusers/${id}`, user);
    return response.data;
  },

  updateUserPassword: async (id: number, password: UpdatePasswordRequest): Promise<void> => {
    await authApiClient.put(`/api/adminusers/${id}/password`, password);
  },

  deleteUser: async (id: number): Promise<void> => {
    await authApiClient.delete(`/api/adminusers/${id}`);
  },
};

// Export convenience function for reset password
export const resetPassword = async (token: string, newPassword: string): Promise<void> => {
  const request: ResetPasswordRequest = { token, newPassword };
  await authApi.resetPassword(request);
};

export default authApiClient;